import React, { useState, useEffect, useRef, useCallback } from "react";
import { Container, Button, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Table, TableHead, TableBody, TableRow, TableCell, CircularProgress } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import WifiIcon from "@material-ui/icons/Wifi";
import WifiOffIcon from "@material-ui/icons/WifiOff";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";  // add IconButton to existing MUI import
import { makeStyles } from "@material-ui/core/styles";
import { GoogleMap, Marker } from "@react-google-maps/api";
import Tooltip from "@material-ui/core/Tooltip";
import LoadingComponent from "../CommonComponents/loadinComponent";
import ExportReport from "../CommonComponents/Export";
import ExportPdf from "../CommonComponents/exportPdf";
import DataTable from "../UserManagement/SubUserManagement/Datatable";
import { PermissionAction } from "../../actions/permission";
import { LocksAction } from "../../actions/lock";
import MapModal from "../NotificationDrawer/MapModal";
import { FilterField } from "../TripConfiguration/util";
import moment from "moment";
import { FaFileExcel } from "react-icons/fa6";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import DownloadIcon from '@mui/icons-material/Download';
import { TripsActionV2 } from "../../actions/TripsV2";
import LockRebootModal from "../VehicleDetailsDashboard/LockRebootModal";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined"
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined"
import * as XLSX from "xlsx";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
// Add this constant at top of LockInventory.js
const LOCK_ICON_BASE64 = `data:image/svg+xml;charset=utf-8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24" height="24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>')}`;

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: "7rem",
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    customTooltip: {
        maxWidth: 320,
        backgroundColor: "#1e293b !important",
        color: "#ffffff !important",
        fontSize: "0.875rem",
        padding: "16px !important",
        borderRadius: "14px !important",
        lineHeight: "1.6",
        boxShadow: "0 20px 25px -5px rgba(0,0,0,0.2)",
        "& .MuiTooltip-arrow": { color: "#1e293b" },
    },
    tooltipPopper: { pointerEvents: "auto !important" },
}));

const showVal = (v) => {
    if (v === null || v === undefined) return "—";
    const s = String(v).trim();
    return s === "" || s.toLowerCase() === "null" ? "—" : s;
};

const ActionButton = ({ children, color, onClick, style = {} }) => (
    <button
        onClick={onClick}
        style={{
            fontSize: "12.5px",
            fontWeight: 600,
            padding: "7px 16px",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            color: "#fff",
            whiteSpace: "nowrap",
            background: `linear-gradient(135deg, ${color}, ${color}cc)`,
            boxShadow: `0 2px 6px ${color}44`,
            transition: "all 0.18s cubic-bezier(0.4, 0, 0.2, 1)",
            letterSpacing: "0.2px",
            outline: "none",
            ...style,
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px) scale(1.03)";
            e.currentTarget.style.boxShadow = `0 6px 14px ${color}55`;
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow = `0 2px 6px ${color}44`;
        }}
        onMouseDown={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(0.97)";
        }}
        onMouseUp={(e) => {
            e.currentTarget.style.transform = "translateY(-1px) scale(1.03)";
        }}
    >
        {children}
    </button>
);


// ── Battery badge helper ──────────────────────────────────
const BatteryBadge = ({ value }) => {
    const fillColor = value >= 60 ? "#10b981" : value >= 30 ? "#f59e0b" : "#ef4444";
    const glow = value >= 60 ? "16,185,129" : value >= 30 ? "245,158,11" : "239,68,68";
    const fillWidth = Math.max(0, Math.min(100, value)) * 0.22;

    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "3px 10px 3px 8px",
                borderRadius: 20,
                background: `linear-gradient(135deg, rgba(${glow},0.08), rgba(${glow},0.14))`,
                boxShadow: `0 2px 5px rgba(${glow},0.18), inset 0 0 0 1px rgba(${glow},0.16)`,
            }}
        >
            <svg width="30" height="15" viewBox="0 0 32 16" fill="none">
                <rect x="0.5" y="0.5" width="27" height="15" rx="3.5" stroke={fillColor} strokeWidth="1.6" fill="none" />
                <rect x="28" y="5" width="3.5" height="6" rx="1.5" fill={fillColor} />
                <rect x="2.5" y="2.5" width={fillWidth} height="11" rx="2" fill={fillColor} style={{ transition: "width 0.3s ease" }} />
            </svg>
            <span style={{ fontSize: 12, fontWeight: 700, color: fillColor, minWidth: 28 }}>
                {value}%
            </span>
        </div>
    );
};

const LockStatusBadge = ({ value }) => {
    const isOnline = value === "Online";
    const color = isOnline ? "#059669" : "#DC2626";
    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "4px 12px",
                borderRadius: 20,
                background: isOnline
                    ? "linear-gradient(135deg, #ECFDF5, #D1FAE5)"
                    : "linear-gradient(135deg, #FEF2F2, #FEE2E2)",
                color,
                fontWeight: 700,
                fontSize: 12,
                boxShadow: `0 2px 5px ${color}26, inset 0 0 0 1px ${color}22`,
            }}
        >
            <span
                style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: color,
                    boxShadow: `0 0 0 3px ${color}22`,
                }}
            />
            {isOnline ? <WifiIcon style={{ fontSize: 14 }} /> : <WifiOffIcon style={{ fontSize: 14 }} />}
            {value}
        </span>
    );
};

const StatusBadge = ({ value }) => {
    const colorMap = {
        IDLE: { from: "#FFF8E1", to: "#FEF0C7", color: "#B45309" },
        ACTIVE: { from: "#ECFDF5", to: "#D1FAE5", color: "#15803D" },
        LOCKED: { from: "#FFF1F2", to: "#FFE4E6", color: "#BE123C" },
    };
    const s = colorMap[value] || { from: "#F5F5F5", to: "#E9E9E9", color: "#6B7280" };
    return (
        <span
            style={{
                display: "inline-block",
                padding: "4px 13px",
                borderRadius: 20,
                background: `linear-gradient(135deg, ${s.from}, ${s.to})`,
                color: s.color,
                fontSize: 11.5,
                fontWeight: 700,
                letterSpacing: "0.4px",
                boxShadow: `0 2px 5px ${s.color}26, inset 0 0 0 1px ${s.color}22`,
            }}
        >
            {value}
        </span>
    );
};

const LockTypeBadge = ({ value }) => {
    if (!value) return <span style={{ color: "#94a3b8" }}>—</span>;
    const label = value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    return (
        <span
            style={{
                display: "inline-block",
                padding: "4px 12px",
                borderRadius: 20,
                background: "linear-gradient(135deg, #F5F0FF, #EDE4FF)",
                color: "#6D28D9",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.3px",
                whiteSpace: "nowrap",
                boxShadow: "0 2px 5px rgba(109,40,217,0.16), inset 0 0 0 1px rgba(109,40,217,0.14)",
            }}
        >
            {label}
        </span>
    );
};



const LockInventory = () => {
    const classes = useStyles();
    const colSettingsRef = useRef(null);
    const importFileRef = useRef(null);
    const [importModal, setImportModal] = useState({
        open: false,
        fileName: "",
        rows: [],        // { rowNo, lockNumber, lockTypeName, lockTypeId, rfidNumber, simNumber, serialNumber, status, message }
        running: false,
        finished: false,
    });
    const [isLoading, setLoading] = useState(false);
    const [searchName, setSearchName] = useState("");

    const [lockList, setLockList] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [exportDataPdf, setExportDataPdf] = useState([]);
    const [pageNo, setPageNo] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [totalPages, setTotalPages] = React.useState(0);
    const [showColSettings, setShowColSettings] = useState(false);
    const [headerConfigs, setHeaderConfigs] = useState([]);
    const [lockDialogOpen, setLockDialogOpen] = useState(false);
    const [lockDialogMode, setLockDialogMode] = useState("add"); // "add" | "edit"
    const [lockFormData, setLockFormData] = useState({ lockNumber: "", vehicleNumber: "", serialNumber: "", lockType: null, rfidNumber: "", simNumber: "", ourSerialNumber: "" });
    const [lockFormError, setLockFormError] = useState({});
    const [lockType, setLockType] = useState(null)
    const [mapModal, setMapModal] = useState({ open: false, lat: null, lng: null });
    const [openLockRebootModal, setOpenLockRebootModal] = React.useState(false)
    const [lockDataToReboot, setLockDataToReboot] = React.useState(null)
    const [proceedingDigilockReboot, setProceedingDigilockReboot] = React.useState(false)

    // Trail modal state
    const [trailModal, setTrailModal] = useState({ open: false, lockNumber: "", data: [], loading: false, pageNo: 0, pageSize: 10, total: 0 });
    // Update (sim/rfid) modal state
    const [updateModal, setUpdateModal] = useState({ open: false, row: null, simNumber: "", rfidNumber: "", loading: false });

    // Assigned Users modal state
    const [assignedUsersModal, setAssignedUsersModal] = useState({ open: false, lockId: null, lockNumber: "", data: [], loading: false });

    // Admin check
    const isAdmin = JSON.parse(localStorage.getItem("data") || "{}").userType === "ADMIN";

    const handleRebootDigiLock = async (data) => {

        console.log("handleRebootDigiLock data : ", data)
        const localData = JSON.parse(localStorage.getItem("data") || "{}");
        const userId = localData?.id;
        setProceedingDigilockReboot(true);
        try {
            const payload = {
                lockNumber: data?.lockNumber || "",
                userId
            };

            const res = await TripsActionV2.rebootDigitalLock(payload);

            if (res?.responseCode === 200) {
                // fetchLockList();
                alert(res?.responseDescription || "Rebooted successfully");
                setOpenLockRebootModal(false); // close only on success
                setLockDataToReboot(null)
            } else {
                alert(res?.responseDescription || "Something went wrong.");
            }
        } catch (e) {
            console.error("Reboot failed:", e);
            alert("Reboot failed. Please try again.");
        } finally {
            setProceedingDigilockReboot(false);
        }
        return;
    };



    const [lockStatusFilter, setLockStatusFilter] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const statusType = params.get("statusType");
        if (statusType === "ONLINE LOCKS") return { name: "Online", value: "Online" };
        if (statusType === "OFFLINE LOCKS") return { name: "Offline", value: "Offline" };
        return { name: "All", value: null };
    });
    const [availabilityFilter, setAvailabilityFilter] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const s = params.get("availabilityStatus");
        if (s === "AVAILABLE") return { name: "Available", value: "AVAILABLE" };
        if (s === "ON_TRIP") return { name: "On Trip", value: "ON_TRIP" };
        return { name: "All", value: null };
    });

    const [batteryFilter, setBatteryFilter] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const b = params.get("batteryCategory");
        if (b === "READY") return { name: "Good", value: "READY" };
        if (b === "LOW") return { name: "Low", value: "LOW" };
        if (b === "DEAD") return { name: "Bad", value: "DEAD" };
        return { name: "All", value: null };
    });
    const handleOpenAddLock = () => {
        setLockDialogMode("add");
        setLockFormData({ lockNumber: "", vehicleNumber: "", serialNumber: "", lockType: null, rfidNumber: "", simNumber: "" });
        setLockFormError({});
        setLockDialogOpen(true);
    };

    const handleOpenUpdateLock = (row) => {
        setUpdateModal({ open: true, row, simNumber: row.simNumber || "", rfidNumber: row.rfidNumber || "", ourSerialNumber: row.ourSerialNumber || "", loading: false });
    };

    const handleCloseUpdateModal = () => {
        setUpdateModal({ open: false, row: null, simNumber: "", rfidNumber: "", ourSerialNumber: "", loading: false });
    };

    const handleSubmitUpdateLock = async () => {
        const { row, simNumber, rfidNumber, ourSerialNumber } = updateModal;
        if (!row?.lockNumber) return;
        try {
            setUpdateModal(prev => ({ ...prev, loading: true }));
            const payload = {
                lockNumber: row.lockNumber,
                simNumber: simNumber ? Number(simNumber) : null,
                rfidNumber: rfidNumber ? Number(rfidNumber) : null,
                ourSerialNumber: ourSerialNumber || "",
            };
            const json = await LocksAction.updateLock(payload);
            if (json && json.responseCode === 200) {
                alert(json.responseDescription || "Lock updated successfully");
                handleCloseUpdateModal();
                fetchLockList(pageNo, pageSize, searchName);
            } else {
                alert(json?.responseDescription || "Failed to update lock");
            }
        } catch (e) {
            console.error("Update lock error:", e);
            alert("Update failed. Please try again.");
        } finally {
            setUpdateModal(prev => ({ ...prev, loading: false }));
        }
    };

    const handleOpenAssignedUsers = async (row) => {
        console.log("rowdddd", row)
        setAssignedUsersModal({ open: true, lockId: row.lockId, lockNumber: row.lockNumber || "", data: [], loading: true });
        try {
            const json = await LocksAction.getLockUserDetails(row.lockId);
            if (json && json.responseCode === 200) {
                setAssignedUsersModal(prev => ({ ...prev, data: Array.isArray(json.data) ? json.data : [], loading: false }));
            } else {
                setAssignedUsersModal(prev => ({ ...prev, data: [], loading: false }));
            }
        } catch (e) {
            console.error("Fetch assigned users error:", e);
            setAssignedUsersModal(prev => ({ ...prev, data: [], loading: false }));
        }
    };

    const handleCloseAssignedUsers = () => {
        setAssignedUsersModal({ open: false, lockId: null, lockNumber: "", data: [], loading: false });
    };

    const handleOpenTrail = async (row, page = 0) => {
        setTrailModal({ open: true, lockNumber: row.lockNumber, data: [], loading: true, pageNo: page, pageSize: 10, total: 0 });
        try {
            const json = await LocksAction.getLockTrail({ lockNumber: row.lockNumber, pageNo: page, pageSize: 10 });
            if (json && json.responseCode === 200) {
                setTrailModal(prev => ({ ...prev, data: json.data || [], total: json.totalElements || 0, loading: false }));
            } else {
                setTrailModal(prev => ({ ...prev, data: [], loading: false }));
                alert(json?.responseDescription || "Failed to fetch trail data");
            }
        } catch (e) {
            console.error("Trail fetch error:", e);
            setTrailModal(prev => ({ ...prev, data: [], loading: false }));
        }
    };

    const handleTrailPageChange = async (newPage) => {
        const { lockNumber, pageSize } = trailModal;
        setTrailModal(prev => ({ ...prev, pageNo: newPage, loading: true }));
        try {
            const json = await LocksAction.getLockTrail({ lockNumber, pageNo: newPage, pageSize });
            if (json && json.responseCode === 200) {
                setTrailModal(prev => ({ ...prev, data: json.data || [], total: json.totalElements || 0, loading: false }));
            } else {
                setTrailModal(prev => ({ ...prev, loading: false }));
            }
        } catch (e) {
            setTrailModal(prev => ({ ...prev, loading: false }));
        }
    };

    const handleOpenEditLock = (row) => {
        setLockDialogMode("edit");
        setLockFormData({
            lockNumber: row.lockNumber || "",
            vehicleNumber: row.vehicleNumber || "",
            serialNumber: row.serialNumber || "",
            lockType: row.lockType ? { name: row.lockType, value: row.lockType } : null,

        });
        setLockFormError({});
        setLockDialogOpen(true);
    };

    const handleCloseLockDialog = () => {
        setLockDialogOpen(false);
        setLockFormData({ lockNumber: "", vehicleNumber: "", serialNumber: "", lockType: null, rfidNumber: "", simNumber: "" });
        setLockFormError({});
    };

    const IMPORT_HEADERS = ["Lock Number", "Lock Type", "RFID Number", "SIM Number", "Serial Number"];

    const normKey = (k) => String(k).toLowerCase().replace(/[^a-z0-9]/g, "");
    const getCell = (row, header) => {
        const target = normKey(header);
        const key = Object.keys(row).find((k) => normKey(k) === target);
        return key ? String(row[key]).trim() : "";
    };

    // ── Template download ──
    const handleDownloadTemplate = () => {
        const wb = XLSX.utils.book_new();

        const ws = XLSX.utils.aoa_to_sheet([
            IMPORT_HEADERS,
            ["LOCK1001", lockType?.[0]?.name || "Fixed Lock", "12345678", "8991102606583665255", "SN-001"],
        ]);
        ws["!cols"] = IMPORT_HEADERS.map(() => ({ wch: 22 }));
        XLSX.utils.book_append_sheet(wb, ws, "Locks");

        // Reference sheet so users copy valid lock type names exactly
        const ref = XLSX.utils.aoa_to_sheet([
            ["Valid Lock Types"],
            ...(lockType || []).map((t) => [t.name]),
        ]);
        ref["!cols"] = [{ wch: 28 }];
        XLSX.utils.book_append_sheet(wb, ref, "Lock Types");

        XLSX.writeFile(wb, "lock_import_template.xlsx");
    };

    const handleDownloadFailedRows = () => {
        const bad = importModal.rows.filter(
            (r) => r.status === "failed" || r.status === "invalid"
        );
        if (bad.length === 0) return;

        const aoa = [
            [...IMPORT_HEADERS, "Error"],
            ...bad.map((r) => [
                r.lockNumber,
                r.lockTypeName,
                r.rfidNumber,
                r.simNumber,
                r.serialNumber,
                r.message || "Unknown error",
            ]),
        ];

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        ws["!cols"] = [22, 22, 22, 26, 22, 50].map((wch) => ({ wch }));
        XLSX.utils.book_append_sheet(wb, ws, "Failed Locks");

        // Keep the valid lock type list so fixes can be copied exactly
        const ref = XLSX.utils.aoa_to_sheet([
            ["Valid Lock Types"],
            ...(lockType || []).map((t) => [t.name]),
        ]);
        ref["!cols"] = [{ wch: 28 }];
        XLSX.utils.book_append_sheet(wb, ref, "Lock Types");

        XLSX.writeFile(
            wb,
            `lock_import_failed_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
        );
    };

    // ── Open / close ──
    const handleOpenImport = () =>
        setImportModal({ open: true, fileName: "", rows: [], running: false, finished: false });

    const handleCloseImport = () => {
        if (importModal.running) return;
        setImportModal((p) => ({ ...p, open: false }));
        if (importModal.finished) refreshLocks();
    };

    // ── Parse + validate file ──
    const handleImportFileChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;
        if (!/\.(xlsx|xls)$/i.test(file.name)) {
            alert("Please upload an .xlsx or .xls file");
            return;
        }

        try {
            const buf = await file.arrayBuffer();
            const wb = XLSX.read(buf, { type: "array" });
            const sheet = wb.Sheets[wb.SheetNames[0]];
            // raw:false keeps long SIM/RFID values as text; defval keeps empty cells
            const json = XLSX.utils.sheet_to_json(sheet, { defval: "", raw: false });

            if (json.length === 0) { alert("The file has no data rows"); return; }
            if (json.length > 500) { alert("Maximum 500 rows per import"); return; }

            const typeMap = {};
            (lockType || []).forEach((t) => {
                typeMap[String(t.name).toLowerCase()] = t;
                if (t.originalType) typeMap[String(t.originalType).toLowerCase()] = t;
            });

            const seen = new Set();
            const rows = json.map((r, i) => {
                const lockNumber = getCell(r, "Lock Number");
                const lockTypeName = getCell(r, "Lock Type");
                const rfidNumber = getCell(r, "RFID Number");
                const simNumber = getCell(r, "SIM Number");
                const serialNumber = getCell(r, "Serial Number");
                const matchedType = typeMap[lockTypeName.toLowerCase()];

                const errs = [];
                if (!lockNumber) errs.push("Lock number is required");
                else if (seen.has(lockNumber.toLowerCase())) errs.push("Duplicate lock number in file");
                if (!lockTypeName) errs.push("Lock type is required");
                else if (!matchedType) errs.push(`Unknown lock type "${lockTypeName}"`);
                if (rfidNumber && !/^\d+$/.test(rfidNumber)) errs.push("RFID must be numeric");
                if (simNumber && !/^\d+$/.test(simNumber)) errs.push("SIM must be numeric");
                if (lockNumber) seen.add(lockNumber.toLowerCase());

                return {
                    rowNo: i + 2, // +2 = header row + 1-based, matches Excel row numbers
                    lockNumber, lockTypeName, rfidNumber, simNumber, serialNumber,
                    lockTypeId: matchedType?.id ?? null,
                    status: errs.length ? "invalid" : "ready",
                    message: errs.join("; "),
                };
            });

            setImportModal((p) => ({ ...p, fileName: file.name, rows, finished: false }));
        } catch (err) {
            console.error("Import parse error:", err);
            alert("Could not read the file. Please use the template.");
        }
    };

    // ── Run import: one addLock call per row, sequentially ──
    const updateImportRow = (idx, patch) =>
        setImportModal((p) => ({
            ...p,
            rows: p.rows.map((r, i) => (i === idx ? { ...r, ...patch } : r)),
        }));

    const refreshLocks = () => {
        const isActive = lockStatusFilter?.value === "Online" ? true
            : lockStatusFilter?.value === "Offline" ? false : null;
        fetchLockList(pageNo, pageSize, searchName, isActive, batteryFilter?.value, availabilityFilter?.value);
    };

    const handleRunImport = async () => {
        const rows = importModal.rows;
        setImportModal((p) => ({ ...p, running: true, finished: false }));

        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            if (r.status !== "ready" && r.status !== "failed") continue; // failed rows get retried

            updateImportRow(i, { status: "processing", message: "" });
            try {
                const json = await LocksAction.addLock({
                    lockNumber: r.lockNumber,
                    lockType: r.lockTypeId,
                    rfidNumber: r.rfidNumber ? Number(r.rfidNumber) : null,
                    simNumber: r.simNumber ? Number(r.simNumber) : null,
                    ourSerialNumber: r.serialNumber || "",
                });
                if (json?.data && json.responseCode === 200) {
                    updateImportRow(i, { status: "success", message: json.responseDescription || "Lock added" });
                } else {
                    updateImportRow(i, { status: "failed", message: json?.responseDescription || "Failed to add lock" });
                }
            } catch (err) {
                updateImportRow(i, {
                    status: "failed",
                    message: err?.response?.data?.responseDescription || err?.message || "Request failed",
                });
            }
        }

        setImportModal((p) => ({ ...p, running: false, finished: true }));
        refreshLocks();
    };

    const addNewLock = async () => {
        try {
            setLoading(true);
            const json = await LocksAction.addLock({
                lockNumber: lockFormData.lockNumber,
                // lockType: lockFormData.lockType?.value || null,
                lockType: lockFormData.lockType?.value || lockFormData.lockType?.id || null,
                rfidNumber: lockFormData.rfidNumber ? Number(lockFormData.rfidNumber) : null,
                simNumber: lockFormData.simNumber ? Number(lockFormData.simNumber) : null,
                ourSerialNumber: lockFormData.ourSerialNumber || "",
            });
            if (json.data && json.responseCode === 200) {
                handleCloseLockDialog()
                alert(json.responseDescription || "Lock added successfully");
                fetchLockList(pageNo, pageSize, searchName, lockStatusFilter?.value === "Online" ? true : lockStatusFilter?.value === "Offline" ? false : null);
            }
            else {
                alert(json.responseDescription || "Failed to add lock");
            }
        } catch (e) {
            console.error("Lock fetch error:", e);
        } finally {
            setLoading(false);

        }
    }

    const editVehicleLock = async () => {
        try {
            setLoading(true);
            const json = await LocksAction.linkVehicle(lockFormData.lockNumber, lockFormData.vehicleNumber);
            if (json.data && json.responseCode === 200) {
                handleCloseLockDialog()
                alert(json.responseDescription + " to " + json?.data?.vehicleNumber || "Lock linked successfully");
                fetchLockList(pageNo, pageSize, searchName, lockStatusFilter?.value === "Online" ? true : lockStatusFilter?.value === "Offline" ? false : null);
            }
            else alert(json.responseDescription || "Failed to link lock");
        } catch (e) {
            console.error("Lock fetch error:", e);
        } finally {
            setLoading(false);

        }
    }



    const unlinkVehicle = async (row) => {
        try {
            setLoading(true);
            const json = await LocksAction.unlinkVehicle(row.lockNumber);
            if (json.data && json.responseCode === 200) {

                alert(json.responseDescription || "Lock unlinked successfully");
                fetchLockList(pageNo, pageSize, searchName, lockStatusFilter?.value === "Online" ? true : lockStatusFilter?.value === "Offline" ? false : null);
            }
            else {
                alert(json.responseDescription || "Failed to unlink lock");
            }
        } catch (e) {
            console.error("Lock fetch error:", e);
        } finally {
            setLoading(false);

        }
    }

    const fetchLockType = useCallback(async () => {
        try {
            const result = await LocksAction.getLockType();
            if (result && result.data && result.responseCode === 200) {
                const mapped = result.data
                    .filter((item) => item.isActive)
                    .map((item) => {
                        let displayName = item.lockType || "";
                        displayName = displayName
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, char => char.toUpperCase());

                        return {
                            name: displayName,           // For display
                            value: item.id,              // ← Now using ID for backend
                            id: item.id,                 // Explicit id
                            originalType: item.lockType  // Keep original if needed
                        };
                    });
                setLockType(mapped);
            } else {
                setLockType([]);
            }
        } catch (error) {
            console.error("Lock type fetch error:", error);
            setLockType([]);
        }
    }, []);

    const handleLockDialogSubmit = () => {
        const errors = {};
        if (!lockFormData.lockNumber.trim()) errors.lockNumber = "Lock number is required";
        if (lockDialogMode === "add" && !lockFormData.lockType) errors.lockType = "Lock type is required";
        if (lockDialogMode === "edit") {
            if (!lockFormData.vehicleNumber.trim()) errors.vehicleNumber = "Vehicle number is required";
            if (!lockFormData.serialNumber.trim()) errors.serialNumber = "Serial number is required";


        }
        if (Object.keys(errors).length > 0) { setLockFormError(errors); return; }

        if (lockDialogMode === "add") addNewLock()
        else {
            editVehicleLock();
        }
        // handleCloseLockDialog();
    };

    const colSettingsKey = "lock_col_settings";

    const [visibleColumns, setVisibleColumns] = useState(() => {
        const saved = localStorage.getItem(colSettingsKey);
        return saved
            ? JSON.parse(saved)
            : {
                sno: true, serialNumber: true, vehicleNumber: true, lockNumber: true, rfidNumber: true,
                simNumber: true, lockStatus: true, status: true, batteryPercentage: true, lastPoolingTime: true, address: true,
                lockType: true,
                actions: true
                // batteryCategory: true, availabilityStatus: true
            };
    });

    const toggleColumn = async (colId) => {
        const nextVal = !visibleColumns[colId];
        setVisibleColumns((prev) => {
            const next = { ...prev, [colId]: nextVal };
            localStorage.setItem(colSettingsKey, JSON.stringify(next));
            return next;
        });

        const stored = JSON.parse(localStorage.getItem("data"));
        if (stored && stored.id && headerConfigs.length > 0) {
            const updatedConfigs = headerConfigs.map((config) => {
                if (config.headerName === colId) {
                    return { ...config, isVisible: nextVal };
                }
                return config;
            });
            await PermissionAction.updateTableHeadersVisibility(updatedConfigs);
            fetchHeaderVisibility();
        }
    };

    const fetchHeaderVisibility = () => {
        const stored = JSON.parse(localStorage.getItem("data"));
        if (stored && stored.id) {
            PermissionAction.getTableHeadersVisibility("LOCK INVENTORY", stored.id).then((res) => {
                if (res && res.data && Array.isArray(res.data)) {
                    setHeaderConfigs(res.data);
                    const apiVisibility = {};
                    res.data.forEach((item) => { apiVisibility[item.headerName] = item.isVisible; });
                    setVisibleColumns((prev) => ({ ...prev, ...apiVisibility }));
                }
            });
        }
    };

    // ADD this fetch function
    const fetchLockList = async (page = 0, size = 10, keyword = "", isActive = null, batteryCategory = null, availabilityStatus = null) => {

        try {
            setLoading(true);
            const json = await LocksAction.getLockList({ pageNo: page, pageSize: size, keyword, isActive, batteryCategory, availabilityStatus });

            if (json.data && Array.isArray(json.data)) {
                const mapped = json.data.map((item) => ({
                    id: item.id,
                    serialNumber: item.serialNumber || "-",
                    vehicleNumber: item.number || "-",
                    lockNumber: item.lockNumber || "-",
                    lockStatus: item.isActive ? "Online" : "Offline",
                    status: item.status || "IDLE",
                    batteryPercentage: item.batteryStatus || 0,
                    lat: item.lat || 0,
                    lng: item.lang || 0,
                    lockId: item.lockId,
                    batteryCategory: item.batteryCategory || "-",
                    availabilityStatus: item.availabilityStatus || "N/A",
                    lockType: item?.elockType?.lockType || null,
                    simNumber: item.simNumber ?? "",
                    rfidNumber: item.rfidNumber ?? "",
                    lastPoolingTime: item.lastPoolingTime
                        ? moment(item.lastPoolingTime).format("DD MMM YYYY, hh:mm A")
                        : "-",
                    userLockPermission: item?.userLockPermission,
                    ourSerialNumber: item.serialNumber || "",
                }));
                setLockList(mapped);
                setTotalPages(json.totalElements || mapped.length);
            }
        } catch (e) {
            console.error("Lock fetch error:", e);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const isActive = lockStatusFilter?.value === "Online" ? true
            : lockStatusFilter?.value === "Offline" ? false : null;
        fetchLockList(pageNo, pageSize, searchName, isActive, batteryFilter?.value, availabilityFilter?.value);
    }, [pageNo, pageSize, lockStatusFilter, batteryFilter, availabilityFilter]);

    useEffect(() => { fetchHeaderVisibility(); fetchLockType() }, []);

    // ── Filter options ──────────────────────────────────────
    const lockStatusOptions = [
        { name: "All", value: null },
        { name: "Online", value: "Online" },
        { name: "Offline", value: "Offline" },
    ];

    const batteryOptions = [
        { name: "All", value: null },
        { name: "Good", value: "READY" },
        { name: "Low", value: "LOW" },
        { name: "Bad", value: "DEAD" },
    ];

    const availabilityOptions = [
        { name: "All", value: null },
        { name: "Available", value: "AVAILABLE" },
        { name: "On Trip", value: "ON_TRIP" },
    ];

    const labelHeader = ["S. No", "Serial Number", "Vehicle Number", "Lock Number", "Lock Type", "Lock Status", "Status", "Battery Percentage (%)", "Last Polling Time", "Address"];
    const exportHeading = "LockList";
    const title = "Lock Inventory";
    const reportName = "lockList";
    const handleChangePage = (event, newPage) => {
        setPageNo(newPage);
        // useEffect will trigger fetchLockList automatically
    };

    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setPageNo(0);
    };

    const applyFilters = (data) => {
        return data.filter((row) =>
            lockStatusFilter?.value == null ? true : row.lockStatus === lockStatusFilter.value
        );
    };

    const exportDataList = (exportArray) => {
        const exportDataArray = exportArray.map((item, index) => ({
            col1: index + 1,
            col2: item.serialNumber,
            col3: item.vehicleNumber,
            col4: item.lockNumber,
            col5: item.lockType || "-",
            col6: item.lockStatus,
            col7: item.status,
            col8: item.batteryPercentage,
            col9: item.lastPoolingTime,
            col10: `${item.lat} , ${item.lng}`,
        }));
        setExportDataPdf(exportDataArray);
        setExportData(exportDataArray);
    };

    const getExportData = async (type) => {
        // if (!lockList || lockList.length === 0) {
        //     alert("No data to export");
        //     return;
        // }

        try {
            setLoading(true);
            const isActive = lockStatusFilter?.value === "Online" ? true : lockStatusFilter?.value === "Offline" ? false : null;
            const json = await LocksAction.getLockList({
                pageNo: 0,
                pageSize: 0,
                keyword: searchName,
                isActive: isActive,
                batteryCategory: batteryFilter?.value,
                availabilityStatus: availabilityFilter?.value
            });

            if (json.data && Array.isArray(json.data)) {
                const mapped = json.data.map((item) => ({
                    id: item.id,
                    serialNumber: item.serialNumber || "-",
                    vehicleNumber: item.number || "-",
                    lockNumber: item.lockNumber || "-",
                    lockStatus: item.isActive ? "Online" : "Offline",
                    status: item.status || "IDLE",
                    batteryPercentage: item.batteryStatus || 0,
                    lat: item.lat || 0,
                    lng: item.lang || 0,
                    batteryCategory: item.batteryCategory || "-",
                    availabilityStatus: item.availabilityStatus || "N/A",
                    lockType: item?.elockType?.lockType || null,
                    lastPoolingTime: item.lastPoolingTime
                        ? moment(item.lastPoolingTime).format("DD MMM YYYY, hh:mm A")
                        : "-",
                }));
                const filtered = applyFilters(mapped);
                exportDataList(filtered);
                if (type === "excel") {
                    setTimeout(() => { document.getElementById("exportDataList").click(); }, 500);
                } else if (type === "pdf") {
                    setTimeout(() => { document.getElementById("exportPdfButton").click(); }, 500);
                }
            } else {
                alert("No data to export");
            }
        } catch (e) {
            console.error("Lock export fetch error:", e);
        } finally {
            setLoading(false);
        }
    };

    const searchFilter = () => {
        setPageNo(0);
        const isActive = lockStatusFilter?.value === "Online" ? true : lockStatusFilter?.value === "Offline" ? false : null;
        fetchLockList(0, pageSize, searchName, isActive, batteryFilter?.value, availabilityFilter?.value);
    };

    useEffect(() => { setPageNo(0); }, [lockStatusFilter, searchName]);

    useEffect(() => {
        const handler = (e) => {
            if (colSettingsRef.current && !colSettingsRef.current.contains(e.target)) {
                setShowColSettings(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const canShowAddButton =
        JSON.parse(localStorage.getItem("data") || "{}").userType === "ADMIN"
        ||
        JSON.parse(localStorage.getItem("data") || "{}")?.userLockPermission?.lockAddAccess
    // JSON.parse(localStorage.getItem("data") || "{}").userType === "CUSTOMER";

    /* ── Column definitions ── */
    const columns = [
        {
            id: "sno",
            label: "S.No.",
            render: (_, index) => (
                <span style={{ fontSize: 13.5, color: "#6B7280", fontWeight: 600 }}>
                    {index + 1 + pageNo * pageSize}
                </span>
            ),
        },
        {
            id: "serialNumber",
            label: "Serial Number",
            render: (row) => (
                <span style={{ fontSize: 13, color: "#374151", fontWeight: 600 }}>{row.serialNumber}</span>
            ),
        },
        {
            id: "lockNumber",
            label: "Lock Number",
            render: (row) => (
                <span
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        padding: "4px 10px",
                        borderRadius: 8,
                        background: "linear-gradient(135deg, #EEF2FF, #E0E7FF)",
                        boxShadow: "0 2px 5px rgba(79,70,229,0.15), inset 0 0 0 1px rgba(79,70,229,0.12)",
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#4338CA",
                    }}
                >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <rect x="5" y="11" width="14" height="9" rx="2" stroke="#4338CA" strokeWidth="2" />
                        <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="#4338CA" strokeWidth="2" fill="none" />
                    </svg>
                    {row.lockNumber}
                </span>
            ),
        },
        {
            id: "rfidNumber",
            label: "RFID Number",
            cellStyle: { textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => (
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <span
                        style={{
                            display: "inline-block",
                            fontSize: 11.5,
                            color: "#475569",
                            fontWeight: 700,
                            padding: "3px 9px",
                            borderRadius: 6,
                            background: "linear-gradient(135deg, #F1F5F9, #E2E8F0)",
                            boxShadow: "inset 0 0 0 1px rgba(71,85,105,0.15)",
                            letterSpacing: "0.3px",
                        }}
                    >
                        {row.rfidNumber || row.rfidNumber === 0 ? row.rfidNumber : "-"}
                    </span>
                </div>
            ),
        },
        {
            id: "simNumber",
            label: "SIM Number",
            cellStyle: { textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => (
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <span
                        style={{
                            display: "inline-block",
                            fontSize: 11.5,
                            color: "#475569",
                            fontWeight: 700,
                            padding: "3px 9px",
                            borderRadius: 6,
                            background: "linear-gradient(135deg, #F1F5F9, #E2E8F0)",
                            boxShadow: "inset 0 0 0 1px rgba(71,85,105,0.15)",
                            letterSpacing: "0.3px",
                        }}
                    >
                        {row.simNumber || row.simNumber === 0 ? row.simNumber : "-"}
                    </span>
                </div>
            ),
        },
        {
            id: "lockType",
            label: "Lock Type",
            render: (row) => <LockTypeBadge value={row.lockType} />,
        },
        {
            id: "vehicleNumber",
            label: "Vehicle Number",
            render: (row) =>
                row.vehicleNumber ? (
                    <span
                        style={{
                            display: "inline-block",
                            fontSize: 11.5,
                            color: "#475569",
                            fontWeight: 700,
                            padding: "3px 9px",
                            borderRadius: 6,
                            background: "linear-gradient(135deg, #F1F5F9, #E2E8F0)",
                            boxShadow: "inset 0 0 0 1px rgba(71,85,105,0.15)",
                            letterSpacing: "0.3px",
                        }}
                    >
                        {row.vehicleNumber}
                    </span>
                ) : (
                    <span style={{ color: "#B0B7C3", fontSize: 12.5, fontStyle: "italic" }}>N/A</span>
                ),
        },
        {
            id: "lockStatus",
            label: "Lock Status",
            render: (row) => <LockStatusBadge value={row.lockStatus} />,
        },
        {
            id: "status",
            label: "Status",
            render: (row) => <StatusBadge value={row.status} />,
        },
        {
            id: "batteryPercentage",
            label: "Battery Percentage (%)",
            render: (row) => {
                const isFixedLock = row.lockType?.toUpperCase().includes("FIXED");
                const isMiniLock = row.lockType?.toUpperCase().includes("MINI");
                if (isFixedLock || isMiniLock) {
                    return <span style={{ color: "#B0B7C3", fontSize: 12.5 }}>—</span>;
                }
                return <BatteryBadge value={row.batteryPercentage} />;
            },
        },
        {
            id: "lastPoolingTime",
            label: "Last Polling Time",
            render: (row) => (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12.5, color: "#636B80", fontWeight: 600 }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="9" stroke="#9CA3AF" strokeWidth="2" />
                        <path d="M12 7v5l3.5 2" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    {row.lastPoolingTime}
                </span>
            ),
        },
        {
            id: "address",
            label: "Address",
            render: (row) =>
                row?.lat && row?.lng ? (
                    <button
                        onClick={() => setMapModal({ open: true, lat: row.lat, lng: row.lng })}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            padding: "4px 11px",
                            borderRadius: 20,
                            border: "none",
                            cursor: "pointer",
                            background: "linear-gradient(135deg, #EFF6FF, #DBEAFE)",
                            color: "#1e40af",
                            boxShadow: "0 2px 5px rgba(30,64,175,0.16), inset 0 0 0 1px rgba(30,64,175,0.14)",
                            fontSize: 12,
                            fontWeight: 700,
                            transition: "transform 0.15s ease, box-shadow 0.15s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-1px)";
                            e.currentTarget.style.boxShadow = "0 5px 12px rgba(30,64,175,0.26), inset 0 0 0 1px rgba(30,64,175,0.18)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 5px rgba(30,64,175,0.16), inset 0 0 0 1px rgba(30,64,175,0.14)";
                        }}
                    >
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                        </svg>
                        {row.lat.toFixed(5)}, {row.lng.toFixed(5)}
                    </button>
                ) : (
                    <span style={{ color: "#B0B7C3", fontSize: 12.5 }}>—</span>
                ),
        },
        {
            id: "actions",
            label: "Actions",
            cellStyle: { minWidth: "360px", whiteSpace: "nowrap" },
            headerStyle: { minWidth: "360px" },
            render: (row) => {
                const hasFixedPerm = JSON.parse(localStorage.getItem("data"))?.hasFixedLockPermission;
                const isFixedLockType = row.lockType?.toUpperCase().includes("FIXED");
                const isElockMini = row.lockType?.toUpperCase() === "ELOCK_MINI";
                return (
                    <div style={{ display: "flex", gap: 6, flexWrap: "nowrap", alignItems: "center" }}>
                        {/* Trail — always visible to everyone */}
                        <ActionButton color="#0369a1" onClick={() => handleOpenTrail(row)}>
                            Trail
                        </ActionButton>
                        {/* Reboot — only if hasFixedLockPermission is falsy */}
                        {/* {!hasFixedPerm && !isElockMini && ( */}
                        {row?.userLockPermission?.lockRebootAccess && (
                            <ActionButton
                                color="#3b82f6"
                                onClick={() => {
                                    setOpenLockRebootModal(true);
                                    setLockDataToReboot(row);
                                }}
                            >
                                Reboot
                            </ActionButton>
                        )}
                        {/* Update — only if this row's lock type is Fixed Lock */}
                        {/* {isFixedLockType && ( */}
                        {canShowAddButton && (
                            <ActionButton color="#16a34a" onClick={() => handleOpenUpdateLock(row)}>
                                Update
                            </ActionButton>
                        )}
                        {/* )} */}
                        {/* Assigned Users — admin only */}
                        {isAdmin && (
                            <ActionButton color="#1e2d5a" onClick={() => handleOpenAssignedUsers(row)}>
                                Users
                            </ActionButton>
                        )}
                    </div>
                );
            },
        },
    ];

    const filteredRows = applyFilters(lockList);
    const paginationCount = totalPages;
    const visibleCols = columns.filter((col) => visibleColumns[col.id]);

    const pagedRows = filteredRows;

    return (
        <div className="sub-user-list-root" style={{ position: "relative" }}>
            <LoadingComponent isLoading={isLoading} />
            <Container>
                {/* ── Page title row ── */}
                <div className="page-title-row">
                    <button
                        className="page-back-btn"
                        onClick={() => window.open("/stats-dashboard", "_self")}
                        aria-label="Go back"
                    >
                        <ArrowBackIcon className="page-back-icon" />
                    </button>
                    <span className="page-title-text">Lock Inventory</span>
                </div>

                {/* ── Hidden export helpers ── */}
                <div style={{ display: "none" }}>
                    <ExportReport
                        exportData={exportData || []}
                        labelHeader={labelHeader || []}
                        exportHeading={[exportHeading]}
                        sheetName={exportHeading}
                    />
                    <ExportPdf
                        exportData={exportDataPdf || []}
                        labelHeader={labelHeader || []}
                        title={title}
                        reportName={reportName}
                    />
                </div>

                <Dialog
                    open={lockDialogOpen}
                    onClose={handleCloseLockDialog}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: "16px",
                            // overflow: "hidden",
                            boxShadow: "0 20px 60px rgba(30,45,90,0.25)",
                        },
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            background: "linear-gradient(135deg, #1e2d5a 0%, #2c4187 100%)",
                            padding: "20px 24px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <div
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "10px",
                                    background: "rgba(255,255,255,0.15)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <KeyOutlinedIcon style={{ color: "#fff", fontSize: 20 }} />
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: "17px", color: "#fff", lineHeight: 1.2 }}>
                                    {lockDialogMode === "add" ? "Add Lock" : "Link Vehicle"}
                                </div>
                                <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", marginTop: "2px" }}>
                                    {lockDialogMode === "add" ? "Register a new digital lock" : "Assign this lock to a vehicle"}
                                </div>
                            </div>
                        </div>
                        <IconButton
                            size="small"
                            onClick={handleCloseLockDialog}
                            style={{
                                color: "#fff",
                                background: "rgba(255,255,255,0.12)",
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>

                    <DialogContent
                        style={{
                            paddingTop: "24px",
                            paddingBottom: "24px",
                            paddingLeft: "24px",
                            paddingRight: "24px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                            background: "#fafbfc",
                        }}
                    >
                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>
                                Lock Number <span style={{ color: "#f44336" }}>*</span>
                            </div>
                            <TextField
                                autoFocus
                                placeholder="Enter Lock Number"
                                variant="outlined"
                                fullWidth
                                size="small"
                                value={lockFormData.lockNumber}
                                onChange={(e) => { setLockFormData(p => ({ ...p, lockNumber: e.target.value })); setLockFormError(p => ({ ...p, lockNumber: "" })); }}
                                error={!!lockFormError.lockNumber}
                                helperText={lockFormError.lockNumber}
                                disabled={lockDialogMode === "edit"}
                                InputProps={{
                                    style: { borderRadius: "10px", background: "#fff" },
                                }}
                            />
                        </div>

                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>
                                Lock Type <span style={{ color: "#f44336" }}>*</span>
                            </div>
                            <Autocomplete
                                size="small"
                                // disablePortal
                                options={lockType || []}
                                getOptionLabel={(option) => option.name || ""}
                                getOptionSelected={(option, value) => option.id === value?.id}
                                value={lockFormData.lockType}
                                onChange={(_, newValue) => {
                                    setLockFormData(p => ({ ...p, lockType: newValue }));
                                    setLockFormError(p => ({ ...p, lockType: "" }));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        placeholder="Select Lock Type"
                                        variant="outlined"
                                        fullWidth
                                        error={!!lockFormError.lockType}
                                        helperText={lockFormError.lockType}
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: "42px", padding: "0 12px", borderRadius: "10px", background: "#fff" },
                                        }}
                                        style={{ height: "42px" }}
                                    />
                                )}
                            // PopperComponent={(props) => (
                            //     <div {...props} style={{ height: "350px" }} />
                            // )}
                            />
                        </div>

                        {lockDialogMode === "add" &&
                            // (lockFormData.lockType?.originalType || lockFormData.lockType?.name || "")
                            //     .toUpperCase()
                            //     .includes("FIXED")
                            //      &&
                            (
                                <>
                                    <div>
                                        <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>
                                            RFID Number
                                        </div>
                                        <TextField
                                            placeholder="Enter RFID Number"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            type="number"
                                            value={lockFormData.rfidNumber}
                                            onChange={(e) => setLockFormData(p => ({ ...p, rfidNumber: e.target.value }))}
                                            InputProps={{ style: { borderRadius: "10px", background: "#fff" } }}
                                        />
                                    </div>
                                    <div>
                                        <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>
                                            SIM Number
                                        </div>
                                        <TextField
                                            placeholder="Enter SIM Number"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            type="number"
                                            value={lockFormData.simNumber}
                                            onChange={(e) => setLockFormData(p => ({ ...p, simNumber: e.target.value }))}
                                            InputProps={{ style: { borderRadius: "10px", background: "#fff" } }}
                                        />
                                    </div>
                                    <div>
                                        <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>
                                            Serial Number
                                        </div>
                                        <TextField
                                            placeholder="Enter Serial Number"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            // type="number"
                                            value={lockFormData.ourSerialNumber}
                                            onChange={(e) => setLockFormData(p => ({ ...p, ourSerialNumber: e.target.value }))}
                                            InputProps={{ style: { borderRadius: "10px", background: "#fff" } }}
                                        />
                                    </div>
                                </>
                            )}



                        {lockDialogMode === "edit" && (
                            <div>
                                <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>
                                    Vehicle Number <span style={{ color: "#f44336" }}>*</span>
                                </div>
                                <TextField
                                    placeholder="Enter Vehicle Number"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    value={lockFormData.vehicleNumber}
                                    onChange={(e) => { setLockFormData(p => ({ ...p, vehicleNumber: e.target.value })); setLockFormError(p => ({ ...p, vehicleNumber: "" })); }}
                                    error={!!lockFormError.vehicleNumber}
                                    helperText={lockFormError.vehicleNumber}
                                    InputProps={{
                                        style: { borderRadius: "10px", background: "#fff" },
                                    }}
                                />
                            </div>
                        )}
                    </DialogContent>

                    <DialogActions
                        style={{
                            padding: "16px 24px 20px",
                            gap: "10px",
                            background: "#fafbfc",
                            borderTop: "1px solid #eef1f5",
                        }}
                    >
                        <Button
                            onClick={handleCloseLockDialog}
                            variant="outlined"
                            style={{
                                borderColor: "#d0d5dd",
                                color: "#475467",
                                minWidth: "90px",
                                borderRadius: "10px",
                                textTransform: "none",
                                fontWeight: 600,
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleLockDialogSubmit}
                            variant="contained"
                            style={{
                                minWidth: "90px",
                                borderRadius: "10px",
                                textTransform: "none",
                                fontWeight: 600,
                                background: "linear-gradient(135deg, #1e2d5a 0%, #2c4187 100%)",
                                boxShadow: "0 4px 12px rgba(30,45,90,0.3)",
                            }}
                        >
                            {lockDialogMode === "add" ? "Add Lock" : "Save"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* ── Update Lock Dialog (sim/rfid only) ── */}
                <Dialog
                    open={updateModal.open}
                    onClose={handleCloseUpdateModal}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{ style: { borderRadius: "16px", boxShadow: "0 20px 60px rgba(30,45,90,0.25)" } }}
                >
                    <div style={{ background: "linear-gradient(135deg, #064e3b 0%, #065f46 100%)", padding: "20px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <div style={{ width: "36px", height: "36px", borderRadius: "10px", background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                </svg>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: "17px", color: "#fff", lineHeight: 1.2 }}>Update Lock</div>
                                <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", marginTop: "2px" }}>Update SIM & RFID numbers</div>
                            </div>
                        </div>
                        <IconButton size="small" onClick={handleCloseUpdateModal} style={{ color: "#fff", background: "rgba(255,255,255,0.12)" }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>
                    <DialogContent style={{ paddingTop: "24px", paddingBottom: "24px", paddingLeft: "24px", paddingRight: "24px", display: "flex", flexDirection: "column", gap: "20px", background: "#fafbfc" }}>
                        {/* Lock Number - disabled */}
                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>Lock Number</div>
                            <TextField variant="outlined" fullWidth size="small" value={updateModal.row?.lockNumber || ""} disabled InputProps={{ style: { borderRadius: "10px", background: "#f1f5f9" } }} />
                        </div>
                        {/* Lock Type - disabled */}
                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>Lock Type</div>
                            <TextField variant="outlined" fullWidth size="small" value={updateModal.row?.lockType || ""} disabled InputProps={{ style: { borderRadius: "10px", background: "#f1f5f9" } }} />
                        </div>
                        {/* SIM Number - editable */}
                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>SIM Number</div>
                            <TextField
                                placeholder="Enter SIM Number"
                                variant="outlined" fullWidth size="small" type="number"
                                value={updateModal.simNumber}
                                onChange={(e) => setUpdateModal(prev => ({ ...prev, simNumber: e.target.value }))}
                                InputProps={{ style: { borderRadius: "10px", background: "#fff" } }}
                            />
                        </div>
                        {/* RFID Number - editable */}
                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>RFID Number</div>
                            <TextField
                                placeholder="Enter RFID Number"
                                variant="outlined" fullWidth size="small" type="number"
                                value={updateModal.rfidNumber}
                                onChange={(e) => setUpdateModal(prev => ({ ...prev, rfidNumber: e.target.value }))}
                                InputProps={{ style: { borderRadius: "10px", background: "#fff" } }}
                            />
                        </div>
                        {/* Serial Number - editable */}
                        <div>
                            <div style={{ marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#334155" }}>Serial Number</div>
                            <TextField
                                placeholder="Enter Serial Number"
                                variant="outlined" fullWidth size="small"
                                value={updateModal.ourSerialNumber}
                                onChange={(e) => setUpdateModal(prev => ({ ...prev, ourSerialNumber: e.target.value }))}
                                InputProps={{ style: { borderRadius: "10px", background: "#fff" } }}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions style={{ padding: "16px 24px 20px", gap: "10px", background: "#fafbfc", borderTop: "1px solid #eef1f5" }}>
                        <Button onClick={handleCloseUpdateModal} variant="outlined" style={{ borderColor: "#d0d5dd", color: "#475467", minWidth: "90px", borderRadius: "10px", textTransform: "none", fontWeight: 600 }}>Cancel</Button>
                        <Button onClick={handleSubmitUpdateLock} variant="contained" disabled={updateModal.loading} style={{ minWidth: "90px", borderRadius: "10px", textTransform: "none", fontWeight: 600, background: "linear-gradient(135deg, #064e3b 0%, #059669 100%)", boxShadow: "0 4px 12px rgba(5,150,105,0.3)" }}>
                            {updateModal.loading ? "Saving..." : "Save"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* ── Trail Modal (Timeline) ── */}
                <Dialog
                    open={trailModal.open}
                    onClose={() => setTrailModal(prev => ({ ...prev, open: false }))}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{ style: { borderRadius: "12px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", overflow: "hidden", display: "flex", flexDirection: "column", maxHeight: "85vh" } }}
                >
                    {/* Header — same dark navy as Digital Lock Trips TrailModal */}
                    <div style={{ background: "#1e2d5a", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                        <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>
                            📍 Lock Trail — {trailModal.lockNumber}
                        </span>
                        <button
                            onClick={() => setTrailModal(prev => ({ ...prev, open: false }))}
                            style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", lineHeight: 1, padding: "0 4px" }}
                        >×</button>
                    </div>

                    {/* Body — scrollable timeline */}
                    <DialogContent style={{ padding: "16px 20px", background: "#fff", overflowY: "auto", flex: 1 }}>
                        {trailModal.loading ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 0", color: "#0369A1", fontSize: 14, fontWeight: 600 }}>
                                Loading trail data...
                            </div>
                        ) : trailModal.data.length === 0 ? (
                            <div style={{ textAlign: "center", padding: "60px 0", color: "#6b7280" }}>
                                {/* <div style={{ fontSize: 32, marginBottom: 8 }}>📭</div> */}
                                <div style={{ fontSize: 14, fontWeight: 600 }}>No trail data available</div>
                            </div>
                        ) : (
                            <>
                                <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 12, letterSpacing: "0.05em", textTransform: "uppercase" }}>
                                    Trail Timeline
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                                    {trailModal.data.map((item, idx) => {
                                        const isLast = idx === trailModal.data.length - 1;
                                        const dotColor = "#0284c7";
                                        const cardBg = "#f0f9ff";
                                        const cardBorder = "#bae6fd";
                                        return (
                                            <div key={idx} style={{ display: "flex", gap: 10 }}>
                                                {/* Dot + connector line */}
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0, width: 20 }}>
                                                    <div style={{ width: 10, height: 10, borderRadius: "50%", background: dotColor, boxShadow: `0 0 0 3px ${cardBg}`, marginTop: 4, flexShrink: 0 }} />
                                                    {!isLast && <div style={{ width: 2, flex: 1, background: "#E5E7EB", minHeight: 20, marginTop: 4 }} />}
                                                </div>
                                                {/* Card */}
                                                <div style={{ flex: 1, paddingBottom: isLast ? 0 : 12 }}>
                                                    <div style={{ padding: "12px 14px", borderRadius: 8, background: cardBg, border: `1px solid ${cardBorder}` }}>
                                                        {/* Lock Number */}
                                                        <div style={{ fontSize: 13, fontWeight: 800, color: "#0c4a6e", marginBottom: 8, letterSpacing: 0.3 }}>
                                                            🔒 {item.lockNumber || "—"}
                                                        </div>
                                                        {/* Updated At */}
                                                        {item.updatedAt && (
                                                            <div style={{ fontSize: 12, color: "#374151", fontWeight: 500, marginBottom: 8 }}>
                                                                🕐 {moment(item.updatedAt).format("DD MMM YYYY, hh:mm A")}
                                                            </div>
                                                        )}
                                                        {/* Details grid */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: (item.updatedBy || item.userName) ? 8 : 0 }}>
                                                            <div>
                                                                <span style={{ fontSize: 10, color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", display: "block", marginBottom: 2 }}>SIM Number</span>
                                                                <div style={{ fontSize: 12, color: "#1e2d5a", fontWeight: 700 }}>{showVal(item.lastSimNo)}</div>
                                                            </div>
                                                            <div>
                                                                <span style={{ fontSize: 10, color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", display: "block", marginBottom: 2 }}>RFID Number</span>
                                                                <div style={{ fontSize: 12, color: "#1e2d5a", fontWeight: 700 }}>{showVal(item.lastRfidNo)}</div>
                                                            </div>
                                                            <div>
                                                                <span style={{ fontSize: 10, color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", display: "block", marginBottom: 2 }}>Serial Number</span>
                                                                <div style={{ fontSize: 12, color: "#1e2d5a", fontWeight: 700 }}>{showVal(item.serialNumber ?? item.ourSerialNumber)}</div>
                                                            </div>
                                                        </div>
                                                        {/* Updated By / Username */}
                                                        {(item.updatedBy || item.userName) && (
                                                            <div style={{ paddingTop: 8, borderTop: `1px solid ${cardBorder}`, display: "flex", gap: 12, flexWrap: "wrap" }}>
                                                                {item.userName && (
                                                                    <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 500 }}>
                                                                        👤 User: <span style={{ color: "#374151", fontWeight: 700 }}>{item.userName}</span>
                                                                    </div>
                                                                )}
                                                                {item.updatedBy && (
                                                                    <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 500 }}>
                                                                        ✏️ Updated by: <span style={{ color: "#374151", fontWeight: 700 }}>{item.updatedBy}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </DialogContent>

                    {/* Footer — pagination + Close */}
                    <div style={{ padding: "12px 20px", borderTop: "1px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0, background: "#fff" }}>
                        <div>
                            {!trailModal.loading && trailModal.total > trailModal.pageSize && (
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <Button disabled={trailModal.pageNo === 0} onClick={() => handleTrailPageChange(trailModal.pageNo - 1)} variant="outlined" size="small" style={{ borderRadius: 6, textTransform: "none", borderColor: "#D1D5DB", color: "#374151", fontWeight: 600 }}>Prev</Button>
                                    <span style={{ fontSize: 12, color: "#6b7280" }}>Page {trailModal.pageNo + 1} of {Math.ceil(trailModal.total / trailModal.pageSize)}</span>
                                    <Button disabled={(trailModal.pageNo + 1) * trailModal.pageSize >= trailModal.total} onClick={() => handleTrailPageChange(trailModal.pageNo + 1)} variant="outlined" size="small" style={{ borderRadius: 6, textTransform: "none", borderColor: "#D1D5DB", color: "#374151", fontWeight: 600 }}>Next</Button>
                                </div>
                            )}
                        </div>
                        <button
                            onClick={() => setTrailModal(prev => ({ ...prev, open: false }))}
                            style={{ padding: "7px 20px", borderRadius: 6, border: "1.5px solid #D1D5DB", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
                        >
                            Close
                        </button>
                    </div>
                </Dialog>

                {/* ── Main card ── */}
                <Paper className="sub-user-list-paper" id="left">
                    {/* ── Toolbar ── */}
                    <div className="sl-toolbar">
                        {/* Left: search + lock status filter */}
                        <div className="sl-toolbar-left">

                            {/* Search */}
                            <FilterField label="Search">
                                <div className="sl-search-wrap">
                                    <input
                                        type="text"
                                        className="sl-search-input"
                                        placeholder="Search by lock number or serial"
                                        value={searchName}
                                        onChange={(e) => setSearchName(e.target.value)}
                                        onKeyDown={(e) => e.key === "Enter" && searchFilter()}
                                    />
                                    <SearchIcon className="sl-search-icon" onClick={searchFilter} />
                                </div>
                            </FilterField>

                            {/* Lock Status filter */}
                            <FilterField label="Lock Status">
                                <Autocomplete
                                    className="sl-filter-autocomplete"
                                    getOptionLabel={(option) => option.name}
                                    options={lockStatusOptions}
                                    value={lockStatusFilter}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    onChange={(_, newValue) => setLockStatusFilter(newValue)}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Lock Status" InputLabelProps={{ shrink: true }} />

                                    )}
                                />
                            </FilterField>

                            <FilterField label="Battery Status">
                                <Autocomplete
                                    className="sl-filter-autocomplete"
                                    getOptionLabel={(option) => option.name}
                                    options={batteryOptions}
                                    value={batteryFilter}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    onChange={(_, newValue) => setBatteryFilter(newValue)}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Battery Status" InputLabelProps={{ shrink: true }} />
                                    )}
                                />
                            </FilterField>

                            <FilterField label="Device Status">
                                <Autocomplete
                                    className="sl-filter-autocomplete"
                                    getOptionLabel={(option) => option.name}
                                    options={availabilityOptions}
                                    value={availabilityFilter}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    onChange={(_, newValue) => setAvailabilityFilter(newValue)}
                                    InputLabelProps={{ shrink: true }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Device Status" InputLabelProps={{ shrink: true }} />
                                    )}
                                />
                            </FilterField>

                        </div>

                        {/* Right: Add Lock + Export */}
                        <div className="sl-toolbar-right">
                            {/* <Button
                                className="sl-btn-export"
                                variant="contained"
                                endIcon={<KeyboardArrowDownIcon />}
                                onClick={() => getExportData("excel")}
                            >
                                Export Excel
                            </Button>

                            <Button
                                className="sl-btn-export"
                                variant="contained"
                                onClick={() => getExportData("pdf")}
                            >
                                Export PDF
                            </Button> */}

                            <Button
                                variant="contained"
                                startIcon={<FaFileExcel style={{ fontSize: 18 }} />}
                                endIcon={<DownloadIcon />}
                                onClick={() => getExportData("excel")}
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6,
                                    height: 40,
                                    padding: "0 18px",
                                    background: "linear-gradient(135deg, #064e3b 0%, #065f46 30%, #047857 60%, #059669 100%)",
                                    color: "#ffffff",
                                    border: "none",
                                    borderRadius: 10,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 4px 16px rgba(6, 78, 59, 0.45)",
                                    whiteSpace: "nowrap",
                                    letterSpacing: "0.3px",
                                }}

                            >
                                Excel
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<BsFileEarmarkPdfFill style={{ fontSize: 18 }} />}
                                onClick={() => getExportData("pdf")}
                                endIcon={<DownloadIcon />}
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6,
                                    height: 40,
                                    padding: "0 18px",
                                    background: "linear-gradient(135deg, #7f1d1d 0%, #991b1b 30%, #b91c1c 60%, #dc2626 100%)",
                                    color: "#ffffff",
                                    border: "none",
                                    borderRadius: 10,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 4px 16px rgba(127, 29, 29, 0.45)",
                                    whiteSpace: "nowrap",
                                    letterSpacing: "0.3px",
                                }}
                            >
                                PDF
                            </Button>
                            {canShowAddButton && (
                                <>
                                    <Button
                                        variant="contained"
                                        startIcon={<CloudUploadIcon />}
                                        onClick={handleOpenImport}
                                        style={{
                                            height: 40, padding: "0 18px", borderRadius: 10, textTransform: "none",
                                            fontSize: 14, fontWeight: 600, color: "#fff", whiteSpace: "nowrap",
                                            background: "linear-gradient(135deg, #0369a1 0%, #0284c7 100%)",
                                            boxShadow: "0 4px 16px rgba(3,105,161,0.4)",
                                        }}
                                    >
                                        Import
                                    </Button>
                                    <Button className="sl-btn-add" variant="contained" onClick={handleOpenAddLock} endIcon={<AddIcon />}>
                                        Add
                                    </Button>
                                </>
                            )}

                            {/* Column settings */}
                            <div className="gf-col-settings-wrap" ref={colSettingsRef}>
                                {/* <button
                                    className={`gf-col-settings-btn ${showColSettings ? "active" : ""}`}
                                    onClick={() => setShowColSettings(!showColSettings)}
                                >
                                    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                                        <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                                    </svg>
                                    Columns
                                    <svg viewBox="0 0 16 16" fill="none" width="12" height="12">
                                        <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button> */}
                                <button
                                    className={`gf-col-settings-btn ${showColSettings ? "active" : ""}`}
                                    onClick={() => setShowColSettings(!showColSettings)}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                        height: 40,
                                        padding: "0 16px",
                                        border: "none",
                                        borderRadius: 10,
                                        background: showColSettings
                                            ? "linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 60%, #475569 100%)"
                                            : "linear-gradient(135deg, #1e293b 0%, #334155 30%, #475569 60%, #64748b 100%)",
                                        color: "#ffffff",
                                        fontSize: 14,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        fontFamily: "inherit",
                                        boxShadow: showColSettings
                                            ? "0 6px 24px rgba(30, 41, 59, 0.55)"
                                            : "0 4px 16px rgba(30, 41, 59, 0.4)",
                                        letterSpacing: "0.3px",
                                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                        transform: showColSettings ? "translateY(-1px)" : "translateY(0)",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = "linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 60%, #475569 100%)";
                                        e.currentTarget.style.boxShadow = "0 6px 24px rgba(30, 41, 59, 0.55)";
                                        e.currentTarget.style.transform = "translateY(-1px)";
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!showColSettings) {
                                            e.currentTarget.style.background = "linear-gradient(135deg, #1e293b 0%, #334155 30%, #475569 60%, #64748b 100%)";
                                            e.currentTarget.style.boxShadow = "0 4px 16px rgba(30, 41, 59, 0.4)";
                                            e.currentTarget.style.transform = "translateY(0)";
                                        }
                                    }}
                                >
                                    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                                        <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                                    </svg>
                                    Columns
                                    <svg viewBox="0 0 16 16" fill="none" width="12" height="12">
                                        <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                {showColSettings && (
                                    <div className="gf-col-dropdown">
                                        <div className="gf-col-dropdown-header">Toggle Columns</div>
                                        {columns.map((col) => (
                                            <label key={col.id} className="gf-col-dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    className="gf-col-checkbox"
                                                    checked={!!visibleColumns[col.id]}
                                                    onChange={() => toggleColumn(col.id)}
                                                />
                                                {col.label}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ── Reusable DataTable ── */}
                    <DataTable
                        columns={visibleCols}
                        rows={pagedRows}
                        rowKey={(row) => row.id}
                        tableId="lock-inventory-table"
                        page={pageNo}
                        rowsPerPage={pageSize}
                        totalCount={paginationCount}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        showRowMenu={false}
                        onRowMenuClick={(row) => console.log("menu clicked", row)}
                        onColumnStateChange={(state) => {
                            console.log("[DataTable] column state persisted:", state);
                        }}
                    />
                </Paper>
            </Container>
            <MapModal
                open={mapModal.open}
                onClose={() => setMapModal({ open: false, lat: null, lng: null })}
                lat={mapModal.lat}
                lng={mapModal.lng}
                label={"Lock Location"}
                notificationType={null}
                alertTime={null}
                tooltipClasses={classes}
                customIconSrc={LOCK_ICON_BASE64}
            />
            <LockRebootModal
                open={openLockRebootModal}
                onClose={() => { setOpenLockRebootModal(false); setLockDataToReboot(null) }}
                onProceed={handleRebootDigiLock}
                loading={proceedingDigilockReboot}
                lockDataToReboot={lockDataToReboot}
            />

            {/* ── Assigned Users Modal ── */}
            <Dialog
                open={assignedUsersModal.open}
                onClose={handleCloseAssignedUsers}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: "12px",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "85vh",
                    },
                }}
            >
                {/* Header — same dark navy as Lock Trail modal */}
                <div style={{ background: "#1e2d5a", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                    <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>
                        👤 Assigned Users — {assignedUsersModal.lockNumber || "—"}
                    </span>
                    <button
                        onClick={handleCloseAssignedUsers}
                        style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", lineHeight: 1, padding: "0 4px" }}
                    >×</button>
                </div>

                {/* Body */}
                <DialogContent style={{ padding: "16px 20px", background: "#fff", overflowY: "auto", flex: 1 }}>
                    {assignedUsersModal.loading ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 0", color: "#0369A1", fontSize: 14, fontWeight: 600 }}>
                            Loading assigned users...
                        </div>
                    ) : assignedUsersModal.data.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "60px 0", color: "#6b7280" }}>
                            <PeopleOutlinedIcon style={{ fontSize: 40, color: "#d1d5db", marginBottom: 8 }} />
                            <div style={{ fontSize: 14, fontWeight: 600 }}>No users assigned to this lock</div>
                        </div>
                    ) : (
                        <>
                            <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", marginBottom: 12, letterSpacing: "0.05em", textTransform: "uppercase" }}>
                                {assignedUsersModal.data.length} User{assignedUsersModal.data.length > 1 ? "s" : ""} Assigned
                            </div>
                            <div style={{ overflowX: "auto" }}>
                                <Table style={{ minWidth: 600 }}>
                                    <TableHead>
                                        <TableRow style={{ background: "#F1F5F9" }}>
                                            <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>S.No</TableCell>
                                            <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>Name</TableCell>
                                            <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>Email</TableCell>
                                            <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>Phone</TableCell>
                                            {/* <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>Gender</TableCell>
                                <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>Address</TableCell>
                                <TableCell style={{ fontWeight: 700, fontSize: 12, color: "#334155", borderBottom: "2px solid #E2E8F0", padding: "10px 16px" }}>Status</TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {assignedUsersModal.data.map((user, idx) => (
                                            <TableRow
                                                key={user.id || idx}
                                                style={{ background: idx % 2 === 0 ? "#fff" : "#F8FAFC", transition: "background 0.15s" }}
                                                onMouseEnter={(e) => { e.currentTarget.style.background = "#F0F9FF"; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.background = idx % 2 === 0 ? "#fff" : "#F8FAFC"; }}
                                            >
                                                <TableCell style={{ fontSize: 13, color: "#6b7280", padding: "10px 16px", borderBottom: "1px solid #F1F5F9" }}>{idx + 1}</TableCell>
                                                <TableCell style={{ fontSize: 13, fontWeight: 600, color: "#1e2d5a", padding: "10px 16px", borderBottom: "1px solid #F1F5F9" }}>{user.name || "—"}</TableCell>
                                                <TableCell style={{ fontSize: 13, color: "#4b5563", padding: "10px 16px", borderBottom: "1px solid #F1F5F9" }}>{user.email || "—"}</TableCell>
                                                <TableCell style={{ fontSize: 13, color: "#4b5563", padding: "10px 16px", borderBottom: "1px solid #F1F5F9" }}>{user.phoneNumber || "—"}</TableCell>
                                                {/* <TableCell style={{ fontSize: 13, color: "#4b5563", padding: "10px 16px", borderBottom: "1px solid #F1F5F9", textTransform: "capitalize" }}>{user.gender || "—"}</TableCell>
                                    <TableCell style={{ fontSize: 13, color: "#4b5563", padding: "10px 16px", borderBottom: "1px solid #F1F5F9" }}>{user.address || "—"}</TableCell>
                                    <TableCell style={{ padding: "10px 16px", borderBottom: "1px solid #F1F5F9" }}>
                                        <span style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            padding: "3px 12px",
                                            borderRadius: 20,
                                            fontSize: 11.5,
                                            fontWeight: 700,
                                            color: user.isActive ? "#059669" : "#DC2626",
                                            background: user.isActive ? "#ECFDF5" : "#FEF2F2",
                                            boxShadow: `inset 0 0 0 1px ${user.isActive ? "#05966922" : "#DC262622"}`,
                                        }}>
                                            <span style={{ width: 6, height: 6, borderRadius: "50%", background: user.isActive ? "#059669" : "#DC2626" }} />
                                            {user.isActive ? "Active" : "Inactive"}
                                        </span>
                                    </TableCell> */}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </>
                    )}
                </DialogContent>

                {/* Footer — matches Lock Trail modal */}
                <div style={{ padding: "12px 20px", borderTop: "1px solid #E5E7EB", display: "flex", justifyContent: "flex-end", alignItems: "center", flexShrink: 0, background: "#fff" }}>
                    <button
                        onClick={handleCloseAssignedUsers}
                        style={{ padding: "7px 20px", borderRadius: 6, border: "1.5px solid #D1D5DB", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
                    >
                        Close
                    </button>
                </div>
            </Dialog>

            {/* ── Import Locks Modal ── */}
            {(() => {
                const { rows, running, finished, fileName } = importModal;
                const count = (s) => rows.filter((r) => r.status === s).length;
                const toProcess = count("ready") + count("failed");
                const statusStyle = {
                    ready: { bg: "#EFF6FF", fg: "#1D4ED8", label: "Ready" },
                    invalid: { bg: "#FEF2F2", fg: "#DC2626", label: "Invalid" },
                    processing: { bg: "#FFFBEB", fg: "#B45309", label: "Processing" },
                    success: { bg: "#ECFDF5", fg: "#059669", label: "Success" },
                    failed: { bg: "#FEF2F2", fg: "#DC2626", label: "Failed" },
                };
                const th = { fontWeight: 700, fontSize: 12, color: "#334155", background: "#F1F5F9", padding: "8px 12px", whiteSpace: "nowrap" };
                const td = { fontSize: 12.5, padding: "8px 12px", borderBottom: "1px solid #F1F5F9" };

                return (
                    <Dialog
                        open={importModal.open}
                        onClose={handleCloseImport}
                        maxWidth="lg"
                        fullWidth
                        PaperProps={{ style: { borderRadius: 12, maxHeight: "88vh", display: "flex", flexDirection: "column" } }}
                    >
                        <div style={{ background: "#1e2d5a", padding: "14px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>Import Locks</span>
                            <button onClick={handleCloseImport} disabled={running}
                                style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: running ? "not-allowed" : "pointer" }}>×</button>
                        </div>

                        <DialogContent style={{ padding: "16px 20px", background: "#fff", flex: 1, overflowY: "auto" }}>
                            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 14 }}>
                                <Button variant="outlined" size="small" startIcon={<GetAppIcon />} onClick={handleDownloadTemplate}
                                    style={{ textTransform: "none", fontWeight: 600, borderRadius: 8 }}>
                                    Download Template
                                </Button>
                                <Button variant="outlined" size="small" startIcon={<CloudUploadIcon />} disabled={running}
                                    onClick={() => importFileRef.current?.click()}
                                    style={{ textTransform: "none", fontWeight: 600, borderRadius: 8 }}>
                                    {fileName ? "Change File" : "Choose Excel File"}
                                </Button>
                                <input ref={importFileRef} type="file" hidden accept=".xlsx,.xls" onChange={handleImportFileChange} />
                                {fileName && <span style={{ fontSize: 12.5, color: "#475569" }}>{fileName}</span>}

                                {(count("failed") + count("invalid")) > 0 && (
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<GetAppIcon />}
                                        onClick={handleDownloadFailedRows}
                                        disabled={running}
                                        style={{
                                            textTransform: "none",
                                            fontWeight: 600,
                                            borderRadius: 8,
                                            color: "#DC2626",
                                            borderColor: "#FCA5A5",
                                        }}
                                    >
                                        Download Failed Rows ({count("failed") + count("invalid")})
                                    </Button>
                                )}
                            </div>

                            {rows.length === 0 ? (
                                <div style={{ textAlign: "center", padding: "50px 0", color: "#6b7280", fontSize: 14 }}>
                                    Download the template, fill it in, then upload it here.
                                </div>
                            ) : (
                                <>
                                    <div style={{ display: "flex", gap: 16, fontSize: 12.5, fontWeight: 600, marginBottom: 10 }}>
                                        <span>Total: {rows.length}</span>
                                        <span style={{ color: "#059669" }}>Success: {count("success")}</span>
                                        <span style={{ color: "#DC2626" }}>Failed: {count("failed")}</span>
                                        <span style={{ color: "#DC2626" }}>Invalid: {count("invalid")}</span>
                                    </div>
                                    <div style={{ overflowX: "auto", border: "1px solid #E2E8F0", borderRadius: 8 }}>
                                        <Table size="small" style={{ minWidth: 850 }}>
                                            <TableHead>
                                                <TableRow>
                                                    {["Row", "Lock Number", "Lock Type", "RFID", "SIM", "Serial", "Status", "Message"].map((h) => (
                                                        <TableCell key={h} style={th}>{h}</TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((r, i) => {
                                                    const s = statusStyle[r.status];
                                                    return (
                                                        <TableRow key={i} style={{ background: r.status === "invalid" || r.status === "failed" ? "#FFF8F8" : "#fff" }}>
                                                            <TableCell style={td}>{r.rowNo}</TableCell>
                                                            <TableCell style={{ ...td, fontWeight: 600 }}>{r.lockNumber || "—"}</TableCell>
                                                            <TableCell style={td}>{r.lockTypeName || "—"}</TableCell>
                                                            <TableCell style={td}>{r.rfidNumber || "—"}</TableCell>
                                                            <TableCell style={td}>{r.simNumber || "—"}</TableCell>
                                                            <TableCell style={td}>{r.serialNumber || "—"}</TableCell>
                                                            <TableCell style={td}>
                                                                <span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "2px 10px", borderRadius: 20, background: s.bg, color: s.fg, fontWeight: 700, fontSize: 11.5 }}>
                                                                    {r.status === "processing" && <CircularProgress size={10} style={{ color: s.fg }} />}
                                                                    {s.label}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell style={{ ...td, color: r.status === "success" ? "#059669" : "#DC2626" }}>
                                                                {r.message || "—"}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </>
                            )}
                        </DialogContent>

                        <DialogActions style={{ padding: "12px 20px", borderTop: "1px solid #E5E7EB", background: "#fff" }}>
                            <Button onClick={handleCloseImport} disabled={running} variant="outlined"
                                style={{ textTransform: "none", fontWeight: 600, borderRadius: 8 }}>
                                {finished ? "Close" : "Cancel"}
                            </Button>
                            <Button onClick={handleRunImport} variant="contained" disabled={running || toProcess === 0}
                                style={{
                                    textTransform: "none", fontWeight: 600, borderRadius: 8, color: "#fff",
                                    background: running || toProcess === 0 ? "#94a3b8" : "linear-gradient(135deg, #1e2d5a 0%, #2c4187 100%)"
                                }}>
                                {running ? "Importing..." : finished && count("failed") > 0 ? `Retry Failed (${count("failed")})` : `Import ${toProcess} Lock${toProcess === 1 ? "" : "s"}`}
                            </Button>
                        </DialogActions>
                    </Dialog>
                );
            })()}
        </div>
    );
};

export default LockInventory;